(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-biglogo"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
        const navbar = document.getElementById("navbar");
        const logo = document.getElementById("logo");

        const section = document.getElementById("shopify-section-header-biglogo");
        section.style.top = 0
        section.style.position = "fixed";
        section.style.zIndex = 100;
        const height = navbar.clientHeight + "px";
        const negativeheight = "-" + navbar.clientHeight + "px";
        const logoHeight = logo.clientHeight + "px"
        const duration = .5
        let isAnimating = false;
        let isMobile = window.innerWidth<=768;

        gsap.set(logo, {       fill: "white", opacity: .8, })
    // Crea l'animazione con GSAP e ScrollTrigger
    if(window.innerWidth> 370
      ) {
        ScrollTrigger.create(
          {
            trigger: "body",
            start: "10px top",
            end: "bottom top",
            markers: true,
            onEnter: () => {
              console.log("ENTER")
              if (isMobile) 
                gsap.to("#logo svg", {
                  marginLeft: "-25%",
                  duration: duration
                })


              


              gsap.to("#header", {backgroundColor: 'white'});

              isAnimating = gsap.fromTo("#logo ", {marginTop: 0}, {
                height: height,
                marginTop: "-" + height,
                duration: duration,

                fill: 'black',
                opacity: 1,
                onComplete: function() {
                  console.log("COMPLETE")
                  gsap.set("#shopify-section-header-biglogo", {
                    position: 'fixed',
                    backgroundColor: 'transparent',
                    top: 0
                  });

    // gsap.set("#mainContent", {marginTop: height})
                }
              });

            },
            onLeaveBack: () => {
              console.log("LEAVEBACK")

    // gsap.set("#logo", {
    // position: "relative",
    // marginTop: 0
    // })
              gsap.set("#logo", {
                position: "relative",
                marginTop: negativeheight,
                fill: "white",
                opacity: .8
              })
              if (isMobile) 
                gsap.to("#logo svg", {
                  marginLeft: "0%",
                  duration: duration
                })


              


              gsap.set("#header", {backgroundColor: 'transparent'});


              gsap.to("#header", {position: 'relative'});
              gsap.set("#mainContent", {marginTop: 0})
              gsap.to("#logo", {
                height: logoHeight,
                marginTop: 0,
                duration: duration,
                onComplete: function() {}
              });
            }
          },
        );
      } else { // Vey small devices
        ScrollTrigger.create({
          trigger: "body",
          start: "10px top",
          end: "bottom top",
          markers: true,
          onEnter: () => {

            isAnimating = gsap.fromTo("#logo ", {marginTop: 0}, {
              height: "20px",
              paddingTop: "2px",
              paddingBottom: "4px",
              paddingRight: "2px",
              paddingLeft: "2px",
              duration: duration,
              onComplete: function() {
                console.log("COMPLETE")
                gsap.set("#shopify-section-header-biglogo", {
                  position: 'fixed',
                  backgroundColor: 'transparent',
                  top: 0
                });
                gsap.to("#header", {backgroundColor: 'transparent'});


  // gsap.set("#mainContent", {marginTop: height})
              }
            });

          },
          onLeaveBack: () => {
            console.log("LEAVEBACK")

            gsap.set("#logo", {
              position: "relative",
              marginTop: negativeheight
            })

            if (isMobile) 
              gsap.to("#logo svg", {
                marginLeft: "0%",
                duration: duration
              })


            


            gsap.to("#header", {
              position: 'relative',
              backgroundColor: 'transparent'
            });
            gsap.set("#mainContent", {marginTop: 0})
            gsap.to("#logo", {
              height: logoHeight,
              marginTop: 0,
              duration: duration,
              onComplete: function() {}
            });
          }
        },);
      }

    }
  );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-home"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// Riferimenti agli elementi DOM
    var announcement = document.querySelector('#announcebar');
    var headerNav = document.querySelector('#navbar');
    var headerBar = document.querySelector('#headerbar');
    var logoWhite = document.querySelector('#logoWhite');
    var logoBlack = document.querySelector('#logoBlack');

    ScrollTrigger.create({
      trigger: document.body,
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {

// Se si sta scorrendo verso il basso e siamo oltre i 50px dal top
        if (self.getVelocity() > 0 && window.scrollY > 50) { // Nascondi l'Announcement Bar
          gsap.to(headerBar, {
            y: - announcement.clientHeight,
            duration: 0.5
          });

// Cambia lo sfondo della navbar
          gsap.to(headerNav, {
            backgroundColor: '#fff',
            duration: 0.5
          });

// Cambia il colore degli elementi all'interno della navbar
          gsap.to(headerNav.querySelectorAll('.text-white'), {
            color: '#000',
            duration: 0.5
          });
          gsap.to(headerNav.querySelectorAll('.border-white'), {
            borderColor: '#000',
            duration: 0.5
          });
          gsap.to(headerNav.querySelectorAll('.bg-transparent'), {
            backgroundColor: '#fff',
            duration: 0.5
          });


// Far scomparire il logo bianco e rivelare il logo nero
          gsap.to(logoWhite, {
            opacity: 0,
            duration: 0.5
          });
          gsap.to(logoBlack, {
            opacity: 1,
            duration: 0.5
          });

        } else if (window.scrollY <= 50) {

// Se siamo tornati in cima
// Mostra di nuovo l'Announcement Bar
          gsap.to(headerBar, {
            y: '0%',
            duration: 0.5
          });

// Ripristina lo sfondo della navbar
          gsap.to(headerNav, {
            backgroundColor: 'transparent',
            duration: 0.5
          });

// Ripristina il colore degli elementi all'interno della navbar
          gsap.to(headerNav.querySelectorAll('.text-white'), {
            color: '#fff',
            duration: 0.5
          });

          gsap.to(headerNav.querySelectorAll('.border-white'), {
            borderColor: '#fff',
            duration: 0.5
          });

          gsap.to(headerNav.querySelectorAll('.bg-transparent'), {
            backgroundColor: 'transparent',
            duration: 0.5
          });

// Far scomparire il logo nero e rivelare il logo bianco
          gsap.to(logoWhite, {
            opacity: 1,
            duration: 0.5
          });
          gsap.to(logoBlack, {
            opacity: 0,
            duration: 0.5
          });
        }
      }
    });

  });

  } catch(e) { console.error(e); }
})();
})();
